module.exports = "build/assets/newsToday.83a2e070.png";